import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../main/ID_store/store';
import { ROLES, constants } from '../../../constants';
import { useHistory } from 'react-router-dom';
import { userLoggedOut } from '../../auth/store/userSlice';
import { injectReducer } from 'app/store';
import { connect } from 'react-redux';
import AuthReducer from 'app/stores/loadz/redux/Auth';
import AuthAction from 'app/stores/loadz/redux/Auth/actions';
import client from 'client';
import ErrorBoundary from 'app/main/ErrorBoundary';
import { hasPermission } from 'app/main/loadz/utils';
import ButtonLog from 'app/main/ButtonLog';
import {useTranslation} from 'react-i18next';

// Cache para no repetir GET /users/:id al remontar (p. ej. resize)
const userInfoCache = new Map();

function UserMenu({ user, resetAuth }) {
  const dispatch = useDispatch();
  const [jsonGetById, setJsonGetById] = useState([]);
  const userProfile = useSelector(({ auth }) => auth.user);
  const [profileImg, setProfileImg] = useState('');
  let history = useHistory();
  const [userMenu, setUserMenu] = useState(null);
  const {t} = useTranslation('navigation');
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  function sendToProfile() {
    history.push('/profile');
  }
  function sendToAccount() {
    history.push('/account');
  }
  function sendToHistory() {
    // history.push('/subscriptions-company');
    history.push('/subscriptions-history');
  }

  const handleSearchUserById = async () => {
    if (!user?.user_id || user?.user_type === ROLES.super_admin) return;
    const cached = userInfoCache.get(user.user_id);
    if (cached) {
      if (!isMountedRef.current) return;
      setJsonGetById(cached);
      return;
    }
    try {
      const userInfo = await client.get(`/users/${user.user_id}`);
      userInfoCache.set(user.user_id, userInfo.data);
      if (!isMountedRef.current) return;
      setJsonGetById(userInfo.data);
    } catch (error) {
      console.log('errorerror => ', error);
    }
  };

  useEffect(() => {
    handleSearchUserById();
  }, []);

  useEffect(() => {
    if (!jsonGetById?.profile_img) return;
    if (!isMountedRef.current) return;
    if (jsonGetById.profile_img.includes('http')) {
      setProfileImg(jsonGetById.profile_img);
    } else {
      setProfileImg(`${constants.URLLOCAL}/aws/signed?image=${jsonGetById.profile_img}`);
    }
  }, [jsonGetById?.profile_img]);

  useEffect(() => {
    if (!user?.profile_img) return;
    if (!isMountedRef.current) return;
    const profile = user.profile_img.includes('http')
      ? user.profile_img
      : `${constants.URLLOCAL}/aws/signed?image=${user.profile_img}`;
    setProfileImg(profile);
  }, [user]);

  const userMenuClick = (event) => {
    setUserMenu(event.currentTarget);
  };

  const userMenuClose = () => {
    setUserMenu(null);
  };

  async function LogOff() {
    // logs user off to prevent auto redirect to dahsboard
    history.replace('/login');
    await ButtonLog({ type: 'auth', button_name: 'auth_logout' });
    localStorage.removeItem('token');
    sessionStorage.clear();
    await store.dispatch({ type: 'LOG_OUT' });
    dispatch(userLoggedOut());
    await resetAuth();
    //resetLocalPersist()
  }

  const resetLocalPersist = () => {
    const storage = localStorage.getItem('persist:root');
    const localStore = JSON.parse(storage);
    const loadz_auth = JSON.stringify({
      AuthReducer: { user: null, loading: false, onboardingSteps: null, credentials: null },
    });
    localStorage.setItem('persist:root', JSON.stringify({ ...localStore, loadz_auth }));
    console.log(JSON.parse(localStorage.getItem('persist:root')));
  };

  return (
    <ErrorBoundary>
      {user?.user_type == 'company' ? (
        <Button
          className='min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6'
          onClick={userMenuClick}
          color='inherit'
        >
          <div className='flex flex-col mx-4 items-end'>
            <Typography component='span' className='font-Regular '>
              {user?.company?.compname}
            </Typography>
            <Typography className='text-11 font-Regular capitalize' color='textSecondary'>
              {user?.user_type}
            </Typography>
            <Typography
              className='text-11 font-Regular capitalize'
              color='textSecondary'
            ></Typography>
          </div>
          <div className='bg-dark p-3 rounded-ss-full userbg'>
            <h1 style={{ color: '#fff' }}>{user?.company?.compname.slice(0, 1)}</h1>
          </div>
        </Button>
      ) : (
        <Button
          className='min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6'
          onClick={userMenuClick}
          color='inherit'
        >
          <div className='flex flex-col mx-4 items-end'>
            <Typography component='span' className='font-Regular '>
              {user?.user_type == ROLES.super_admin
                ? user?.user_fname
                : `${user?.staff?.staff_fname} ${user?.staff?.staff_lname}`}
              {/* {user?.staff?.staff_fname} {user?.staff?.staff_lname} */}
            </Typography>
            <Typography className='text-11 font-Regular capitalize' color='textSecondary'>
              {user?.user_type}
            </Typography>
            <Typography
              className='text-11 font-Regular capitalize'
              color='textSecondary'
            ></Typography>
          </div>
          <div className='bg-dark p-3 rounded-ss-full userbg'>
            <h1 style={{ color: '#fff' }}>
              {user?.user_type == ROLES.super_admin
                ? user?.user_fname.slice(0, 1)
                : user?.staff?.staff_fname.slice(0, 1)}
            </h1>
          </div>
        </Button>
      )}
      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8 login-profile-main',
        }}
      >
        <>
          {user?.user_type == ROLES.super_admin ? (
            <div className='login-profile' style={{ backgroundColor: '#FFFFFF' }}>
              <MenuItem onClick={LogOff} style={{ backgroundColor: '#FFFFFF' }}>
                <ListItemIcon className='min-w-40' style={{ backgroundColor: '#FFFFFF' }}>
                  <Icon>exit_to_app</Icon>
                </ListItemIcon>
                <ListItemText primary='Logout' />
              </MenuItem>
            </div>
          ) : (
            <div className='login-profile' style={{ backgroundColor: '#FFFFFF' }}>
              {hasPermission('jobs.update') && (
                <>
                  <MenuItem onClick={sendToAccount}>
                    <ListItemIcon className='min-w-40' style={{ backgroundColor: '#FFFFFF' }}>
                      <img src='assets/images/icons/user-icon.svg' />
                    </ListItemIcon>
                    <ListItemText role='button' primary={t('MY_ACCOUNT')} />
                  </MenuItem>
                </>
              )}
              <MenuItem onClick={LogOff} style={{ backgroundColor: '#FFFFFF' }}>
                <ListItemIcon className='min-w-40' style={{ backgroundColor: '#FFFFFF' }}>
                  <Icon>exit_to_app</Icon>
                </ListItemIcon>
                <ListItemText primary={t('LOGOUT')} />
              </MenuItem>
            </div>
          )}
        </>
      </Popover>
    </ErrorBoundary>
  );
}

injectReducer('loadz_auth', AuthReducer);

const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth.AuthReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => ({
  resetAuth: () => dispatch(AuthAction.resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
